export default ({
  namespaced: true,
  state: {
    productos: [],
    codClase: '',
    comparar: false,
    productoSeleccionado: null
  },
  mutations: {
    agregarProductoComparar (state, producto) {
      const index = state.productos.findIndex(p => p.codigo === producto.codigo)
      if (index !== -1) {
        state.productos.splice(index, 1)
      } else {
        state.productos.push({ codigo: producto.codigo, imagen: producto.imagen })
        if (state.productos.length === 1) {
          state.codClase = producto.codClase
        }
      }
      if (state.productos.length === 0) {
        state.codClase = ''
      }
    },
    quitarProductoComparar (state, codigo) {
      state.productos = state.productos.filter(p => p.codigo !== codigo)
      if (state.productos.length === 0) {
        state.codClase = ''
      }
    },
    vaciarComparador (state) {
      state.productos = []
      state.codClase = ''
      state.comparar = false
    },
    setComparar (state, value) {
      state.comparar = value
    },
    setProductoSeleccionado (state, value) {
      state.productoSeleccionado = value
    }
  },
  actions: {
    async agregarProductoComparar ({ commit }, producto) {
      await commit('agregarProductoComparar', producto)
    },
    async quitarProductoComparar ({ commit }, codigo) {
      await commit('quitarProductoComparar', codigo)
    },
    async vaciarComparador ({ commit }) {
      await commit('vaciarComparador')
    },
    setComparar ({ commit }, value) {
      commit('setComparar', value)
    },
    setProductoSeleccionado ({ commit }, value) {
      commit('setProductoSeleccionado', value)
    }
  }
})
